import {
  init,
  browserTracingIntegration,
  replayIntegration,
  captureConsoleIntegration
} from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import { version } from '../../package.json'

const initSentry = (app: App | App[], router: Router) => {
  if (import.meta.env.VITE_APP_SENTRY_URL) {
    init({
      app,
      dsn: import.meta.env.VITE_APP_SENTRY_URL,
      environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
      release: `ap2-frontend@${version}`,
      integrations: [
        browserTracingIntegration({ router }),
        replayIntegration(),
        captureConsoleIntegration({ levels: ['error'] })
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: ['AxiosError']
    })
  }
}

export default initSentry
